import React from "react";
import Link from "next/link";
import styles from "./mentor_join.module.scss";

export const MentorJoin = () => {
  return (
    <section className={styles.section_mentor_join}>
      <div className="container">
        <div className={styles.wrapper}>
          <h2 className={styles.title}>Join with us as a Mentor</h2>
          {/* <p className={"font-medium"}>
            Adipiscing elit. Quam donec sapien id enim, fermentum, amet, rhoncus
            ac cursus. Et, tortor ullamcorper sit sed commodo turpis ullamcorper
            risus. Tincidunt in scelerisque donec neque tempor integer. Interdum
            justo metus malesuada nisi elit eget purus.
          </p> */}
          <Link legacyBehavior href="/signup-mentor">
            <a className={`${styles.link_btn} btn btn-white btn-bg`}>
              Join Now
            </a>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default MentorJoin;
